/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetHerdQueryResponse, GetHerdPathParams, GetHerd400, GetHerd401, GetHerd403, GetHerd404, GetHerd409, GetHerd500 } from "../../types/livestockController/GetHerd.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getHerd } from "../../client/livestockController/getHerd.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getHerdQueryKey = (organizationId: GetHerdPathParams["organizationId"] | undefined, herdId: GetHerdPathParams["herdId"] | undefined) => [{ url: '/api/organizations/:organizationId/livestock/herds/:herdId', params: {organizationId:organizationId,herdId:herdId} }] as const

export type GetHerdQueryKey = ReturnType<typeof getHerdQueryKey>

export function getHerdQueryOptions(organizationId: GetHerdPathParams["organizationId"] | undefined, herdId: GetHerdPathParams["herdId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getHerdQueryKey(organizationId, herdId)
        return queryOptions<GetHerdQueryResponse, ResponseErrorConfig<GetHerd400 | GetHerd401 | GetHerd403 | GetHerd404 | GetHerd409 | GetHerd500>, GetHerdQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && herdId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getHerd(organizationId!, herdId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get livestock herd by ID
 * {@link /api/organizations/:organizationId/livestock/herds/:herdId}
 */
export function useGetHerd<TData = GetHerdQueryResponse, TQueryData = GetHerdQueryResponse, TQueryKey extends QueryKey = GetHerdQueryKey>(organizationId: GetHerdPathParams["organizationId"] | undefined, herdId: GetHerdPathParams["herdId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetHerdQueryResponse, ResponseErrorConfig<GetHerd400 | GetHerd401 | GetHerd403 | GetHerd404 | GetHerd409 | GetHerd500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getHerdQueryKey(organizationId, herdId)
         

         const query = useQuery({
          ...getHerdQueryOptions(organizationId, herdId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetHerd400 | GetHerd401 | GetHerd403 | GetHerd404 | GetHerd409 | GetHerd500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}